import { VolumeLabelString } from "../types/general";
import { VOLUME } from "./constants";

// Map labels to numeric levels (index-based for simplicity)
export const volumeMap: { [key in VolumeLabelString]: number } = {
    Mute: 0,
    Low: 1,
    Medium: 2,
    High: 3,
    Max: 4,
} as const;

export const labelMap: Record<number, VolumeLabelString> = Object.entries(volumeMap).reduce(
    (acc, [label, level]) => {
        acc[level] = label as VolumeLabelString;
        return acc;
    },
    {} as Record<number, VolumeLabelString>,
);

// Utility functions
export const VolumeUtils = {
    // Convert level to label
    getLabel: (level: number): VolumeLabelString => {
        return labelMap[Math.round(level)] ?? "Medium";
    },

    // Convert label to level
    fromLabel: (label: VolumeLabelString): number => {
        return volumeMap[label] ?? 2;
    },

    // Normalize to 0–1
    toNormalized: (level: number): number => {
        return Math.max(0, Math.min(1, level / 4));
    },

    // From normalized value (0–1) back to level (0–4)
    fromNormalized: (value: number): number => {
        return Math.round(Math.max(0, Math.min(1, value)) * 4);
    },

    // Position ratio → volume level (0–4)
    fromPositionRatio: (ratio: number): number => {
        return Math.round(Math.max(0, Math.min(1, ratio)) * 4);
    },

    // Volume level → position ratio
    toPositionRatio: (level: number): number => {
        return Math.max(0, Math.min(4, level)) / 4;
    },

    // Get all numeric levels
    getAllLevels: (): number[] => [0, 1, 2, 3, 4],

    // Get all label strings
    getAllLabels: (): VolumeLabelString[] => [...VOLUME.LABELS],

    // Increment/decrement with bounds
    increment: (current: number): number => Math.min(4, current + 1),
    decrement: (current: number): number => Math.max(0, current - 1),
};
